import React from "react";

import { useUpdateUserExperienceFlagsMutation } from "EmployerApplication/api";
import { setFilter } from "QuotePage/Actions";
import { quotePageURL } from "QuotePage/urls";
import { useDispatch, useSelector } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Row, Col } from "Common/Grid";
import { Div, Li, Ul } from "Common/HTML";
import { appendAuthParams } from "Common/TokenAuth/Utils";
import Button from "Theme/Button";

import makeBem from "Utils/makeBem";

const bem = makeBem("ApplicationStepCard");

const OutOfStateIssue = ({ outOfStateEmployees }) => {
  const companyIDToken = useSelector((state) => state.companyProfile?.idToken);
  const [updateUserExperienceFlags] = useUpdateUserExperienceFlagsMutation();
  const dispatch = useDispatch();
  const employeeNames = outOfStateEmployees.map((employee) => employee.employee_name);

  const submitHandler = async () => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "out_of_state_page",
      action: "change_plan",
    });

    dispatch(setFilter("out_of_state", { include: [true] }));

    updateUserExperienceFlags({
      companyIDToken,
      out_of_state_issue: true,
    });

    window.location.replace(appendAuthParams(quotePageURL()));
  };

  return (
    <Col>
      <Row>
        <Div className={bem("PendingItemsLabel")}>The plan you&apos;ve chosen does not cover out of state employees.</Div>
      </Row>
      <Row pt={4}>
        <Div>The following employees are entered as out of state:</Div>
      </Row>
      <Row pt={2}>
        <Ul>
          {employeeNames.map((employeeName) => (
            <Li>{employeeName}</Li>
          ))}
        </Ul>
      </Row>
      <Row pt={4}>
        <Div>
          In order to make sure the aforementioned employees have coverage, please select a new plan using the button below. You&apos;ll be taken to the quote
          page with the Out of State Filter applied.
        </Div>
      </Row>
      <Row pt={4}>
        <Col>
          <Button onClick={submitHandler} className="float-right" size="small" mt={3}>
            View Plans
          </Button>
        </Col>
      </Row>
    </Col>
  );
};

export default OutOfStateIssue;
